import React from 'react';
import { Form } from 'antd';
import styles from './FormFieldItem.module.scss';

const FormFieldItem = ({ label, required, errorMessage, children }) => (
  <Form.Item
    className={styles.root}
    label={label}
    required={required}
    validateStatus={errorMessage ? 'error' : undefined}
    help={errorMessage}
    colon={false}
  >
    {children}
  </Form.Item>
);

export default FormFieldItem;
